function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "client-24-px_svg__a",
  d: "M1.038 11.943C1.038 10.318 2.428 9 4.147 9c1.346 0 2.492.81 2.924 1.942a6.914 6.914 0 003.892 2.527l.037.008-.044.032c-.652.486-1.072 1.24-1.072 2.084 0 .593.206 1.14.555 1.582l-.016-.009-.014-.004-.063-.021a6.892 6.892 0 01-3.123-2.155L7.227 23H1l.038-11.035v-.022zm16-7.943a3 3 0 106 0 3 3 0 00-6 0zm-13-3a3 3 0 11.001 6 3 3 0 010-6zm8.643 12.575c-.95.128-1.681.92-1.681 1.88 0 1.048.874 1.896 1.951 1.896.188 0 .37-.025.541-.073l.09-.036a6.723 6.723 0 003.353-2.251V23H23l-.009-11.056c0-1.626-1.355-2.944-3.028-2.944-1.279 0-2.372.77-2.816 1.858l-.016.019a6.73 6.73 0 01-4.352 2.696l-.098.002z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "client-24-px_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#client-24-px_svg__a"
})), React.createElement("g", {
  fill: "#000",
  fillOpacity: 0.54,
  mask: "url(#client-24-px_svg__b)"
}, React.createElement("path", {
  d: "M0 0h24v24H0z"
})));

var SvgClient24Px = function SvgClient24Px(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref, _ref2);
};

export default SvgClient24Px;